var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('MainHeader'),_c('div',{staticClass:"f-fs-s",attrs:{"id":"body"}},[_c('TreeMenu',{attrs:{"menus":_vm.menus}}),_c('div',{attrs:{"id":"main"}},[_c('div',{attrs:{"id":"router-view-box"}},[_c('RouterView')],1),_c('MainFooter')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }